import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_479: DocMigration = {
  maxSchemaVersion: "0.0.479",
  description: "Set default export permissions for existing PlanSetTemplates to have sales_manager checked by default",
  apply(json: any): any {
    const { planSetTemplates = {} } = json;

    for (const planSetTemplateId in planSetTemplates) {
      const planSetTemplate = planSetTemplates[planSetTemplateId];

      planSetTemplates[planSetTemplateId] = {
        ...planSetTemplate,
        exportPermissions: {
          ...planSetTemplate.exportPermissions,
          sales_manager: true,
        },
      };
    }

    json.planSetTemplates = planSetTemplates;
    return json;
  },
};

export default migration_0_0_479;
